module.exports = __webpack_public_path__ + "img/DIlo_image_1.2507730c.jpeg";